import { useEffect, useMemo, useState } from "react";
import AdminSidebarShell from "../components/AdminSidebarShell";
import config from "../config";

const emptyProfile = {
  firstName: "",
  lastName: "",
  country: "",
  city: "",
  spokenLanguage: "",
  whatsapp: ""
};

const AdminProfilePage = () => {
  const apiBase = useMemo(() => config.API_BASE_URL || "http://localhost:5003", []);
  const token = useMemo(() => localStorage.getItem("token"), []);
  const [form, setForm] = useState(emptyProfile);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) return;
    fetch(`${apiBase}${config.ADMIN.PROFILE}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((res) => res.json())
      .then((payload) => {
        setForm({
          firstName: payload.firstName || "",
          lastName: payload.lastName || "",
          country: payload.country || "",
          city: payload.city || "",
          spokenLanguage: payload.spokenLanguage || "",
          whatsapp: payload.whatsapp || ""
        });
      })
      .catch(() => {
        setError("Failed to load profile");
      });
  }, [apiBase, token]);

  const update = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setStatus("");
    setError("");
    try {
      const response = await fetch(`${apiBase}${config.ADMIN.PROFILE}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(form)
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload?.error || "Failed to update profile");
      setStatus("Profile updated");
    } catch (err) {
      setError(err.message || "Failed to update profile");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminSidebarShell activeItem="profile">
      <div style={wrap}>
        <form style={card} onSubmit={submit}>
          <h1 style={title}>Update Personal Profile</h1>
          <Input label="First Name" value={form.firstName} onChange={(v) => update("firstName", v)} />
          <Input label="Last Name" value={form.lastName} onChange={(v) => update("lastName", v)} />
          <Input label="Country" value={form.country} onChange={(v) => update("country", v)} />
          <Input label="City" value={form.city} onChange={(v) => update("city", v)} />
          <Input
            label="Spoken Language"
            value={form.spokenLanguage}
            onChange={(v) => update("spokenLanguage", v)}
          />
          <Input
            label="WhatsApp / Phone"
            value={form.whatsapp}
            onChange={(v) => update("whatsapp", v)}
          />
          {status ? <p style={statusText}>{status}</p> : null}
          {error ? <p style={errorText}>{error}</p> : null}
          <button style={button} type="submit" disabled={loading}>
            {loading ? "Saving..." : "Save Profile"}
          </button>
        </form>
      </div>
    </AdminSidebarShell>
  );
};

const Input = ({ label, value, onChange }) => (
  <label style={field}>
    <span style={labelStyle}>{label}</span>
    <input style={input} value={value} required onChange={(e) => onChange(e.target.value)} />
  </label>
);

export default AdminProfilePage;

const wrap = {
  maxWidth: "900px",
  margin: "0 auto"
};

const card = {
  background: "#fff",
  border: "1px solid #d9e5ef",
  borderRadius: "16px",
  boxShadow: "0 12px 32px rgba(15,23,42,0.08)",
  padding: "24px",
  display: "grid",
  gap: "12px"
};

const title = {
  margin: 0,
  color: "#0E5580"
};

const field = {
  display: "grid",
  gap: "6px"
};

const labelStyle = {
  fontSize: "14px",
  color: "#334155",
  fontWeight: "600"
};

const input = {
  border: "1px solid #cbd5e1",
  borderRadius: "10px",
  padding: "14px 16px",
  fontSize: "18px"
};

const button = {
  border: "none",
  borderRadius: "10px",
  minHeight: "52px",
  padding: "14px 16px",
  background: "#0E5580",
  color: "#fff",
  fontSize: "18px",
  fontWeight: "700",
  cursor: "pointer"
};

const statusText = {
  margin: 0,
  color: "#166534"
};

const errorText = {
  margin: 0,
  color: "#b91c1c"
};
